export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '0.17.1',
    name: 'orga-app-admin-client',
    versionDate: '2026-10-30T14:57:39.896Z',
    description: 'ORGA App Admin Client',
    gitCommitHash: 'd2d4d11',
    versionLong: '0.17.1-d2d4d11',
};
export default versions;
